<template>
  <div class="rating-card-list-dropdown__opener">
    <div
      v-for="value in filteredValues"
      v-show="value.openValue && activeId === value.id"
      :key="value.id"
      class="rating-card-list-dropdown__opener-table"
    >
      <div class="rating-card-list-dropdown__opener-item">
        <div class="rating-card-list-dropdown__opener-text">
          Людей с более чем 0 рублей:<b>
            {{ value.openValue.peopleNot0Count }} участников</b
          >
        </div>
        <div class="rating-card-list-dropdown__opener-text">
          Выросли на более 10%:<b>
            {{ value.openValue.more.growth10.people }} участников</b
          >
          ({{ value.openValue.more.growth10.percent }}%)
        </div>
        <div class="rating-card-list-dropdown__opener-text">
          Выросли на более 20%:<b>
            {{ value.openValue.more.growth20.people }} участников</b
          >
          ({{ value.openValue.more.growth20.percent }}%)
        </div>
        <div class="rating-card-list-dropdown__opener-text">
          Выросли на более 50%:<b>
            {{ value.openValue.more.growth50.people }} участников</b
          >
          ({{ value.openValue.more.growth50.percent }}%)
        </div>
        <div class="rating-card-list-dropdown__opener-text">
          Выросли на более 100%:<b>
            {{ value.openValue.more.growth100.people }} участников</b
          >
          ({{ value.openValue.more.growth100.percent }}%)
        </div>
      </div>
      <div class="rating-card-list-dropdown__opener-item">
        <div class="rating-card-list-dropdown__opener-text">
          Людей с 0 рублей:<b>
            {{ value.openValue.peopleWith0Count }} участников</b
          >
        </div>
        <div class="rating-card-list-dropdown__opener-text">
          Заработали первые деньги:<b>
            {{ value.openValue.more.firstMoney.people }} участников</b
          >
          ({{ value.openValue.more.firstMoney.percent }}%)
        </div>
        <div class="rating-card-list-dropdown__opener-text">
          Заработали с нуля более 8к:<b>
            {{ value.openValue.more.first8k.people }} участников</b
          >
          ({{ value.openValue.more.first8k.percent }}%)
        </div>
        <div class="rating-card-list-dropdown__opener-text">
          Заработали с нуля более 16к:<b>
            {{ value.openValue.more.first16k.people }} участников</b
          >
          ({{ value.openValue.more.first16k.percent }}%)
        </div>
        <div class="rating-card-list-dropdown__opener-text">
          Заработали с нуля более 100к:<b>
            {{ value.openValue.more.first100k.people }} участников</b
          >
          ({{ value.openValue.more.first100k.percent }}%)
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    values: {
      type: Array
    },
    activeId: {
      type: Number
    }
  },
  computed: {
    filteredValues() {
      return this.values.filter(item => !(item.canOpen && item.openValue));
    }
  }
};
</script>
